"use client";

export function ClearPreferencesButton() {
  function handleClear() {
    localStorage.removeItem("design-theme");
    localStorage.removeItem("background-mode");
    window.location.reload();
  }

  return (
    <button
      onClick={handleClear}
      data-faro-user-action-name="clear-preferences"
      className="text-sm underline underline-offset-4 hover:text-foreground text-muted-foreground"
    >
      Clear preferences
    </button>
  );
}
